/*=====================================
    GameSaleView

    Author: Ac
    CreateTime: 2018 / 10 / 03
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
// import CupoyListRepeat from 'components/commons/CupoyListRepeat';
import GLOBAL from 'nonnglobal';
import CupoyInfiniteScroll from 'components/commons/CupoyInfiniteScroll';

/*--------------------------
    Styled
--------------------------*/
const Container = GlobalStyle.BasicBlock.extend`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;
const Header = styled.div`
    height: 54px;
    background-color: #F5F5F5;
    display: grid;
    grid-template-columns: repeat(4, 1fr) 2fr 1fr;
    justify-items: center;
    align-items: center;
`;
const HeaderText = styled.div`
    font-size: 14px;
    color: #4a4a4a;
    font-weight: bold;
`;
const List = styled.div`
`;
const ListItem = styled.div`
    padding: 16px 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr) 2fr 1fr;
    grid-gap: 10px;
    justify-items: center;
    align-items: center;
    border-top: solid 1px #D9D9D9;
`;
const Name = styled.span`
    width: 100%;
    text-align: left;
    padding-left: 24px;
    font-size: 14px;
    
    &::before {
        content: '';
        background-color: ${({ isOpen }) => isOpen ? '#54B62C' : '#D0021B'};
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 10px;
    }
`;
const Star = styled.i`
    color: #4A90E2;
    font-size: 18px;
`;
const Money = styled.div`
    color: ${Colors.MAIN_COLOR};
`;
const Stock = styled.div`
    font-size: 14px;
`;
const Info = styled.div`
    font-size: 14px;
`;
const Button = styled.button`
    background-color: ${Colors.MAIN_COLOR};
    border: none;
    border-radius: 2px;
    font-weight: bold;
    padding: 2px 12px;
    color: #fff;
    opacity: ${({ disable }) => disable ? .5 : 1 };
    cursor: ${({ disable }) => disable ? 'auto' :  'pointer'};
`;
/*--------------------------
    Main Component
--------------------------*/
class GameSaleView extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        const routerState = CupoyRouter.getCurrent();
        const { params } = routerState;
        const { gameid, serverid } = params;

        this.state = {
            gameid,
            serverid,
            start: 0,
        };
    }

    componentDidMount() {

        const {
            gameid, 
            serverid: gameserverid,
        } = this.state;

        const sellerListIdsByGameAndServerId = this.props.sellerListIdsByGameAndServerId[`${gameid},${gameserverid}`];

        if(!Array.isArray(sellerListIdsByGameAndServerId) || sellerListIdsByGameAndServerId.length === 0) {   
            this.fetchSeller();
        }
    }

    fetchSeller = () => {

        const {
            isLoadingList,
            isEmpty,
            gameid,
            serverid: gameserverid,
        } = this.state;

        if(isLoadingList || isEmpty)
            return;

        this.setState({
            isLoadingList: true,
        }, () => {

            this.props.vitemActions.getVItemTopSellerListForGame({gameid, gameserverid}).then((result) => {

            this.setState({
                topLen: result.resultSize,
                isLoadingList: false,
            }, () => {
                this.props.vitemActions.getVItemSellerListForGame(
                    {
                        gameid, gameserverid,
                        start: this.state.start
                    }
                ).then(()=>{

                    const sellerListIdsByGameAndServerId = this.props.sellerListIdsByGameAndServerId[`${gameid},${gameserverid}`];

                    if(!Array.isArray(sellerListIdsByGameAndServerId) || sellerListIdsByGameAndServerId.length === 0){
                        this.setState({
                            isEmpty: true,
                        });
                    } else {
                        this.setState({
                            start: sellerListIdsByGameAndServerId.length,
                        });
                    }
                });
            });
        })});
    }

    showLogin = () => {
        this.props.webActions.showSignInDialog();
    }

    render() {

        const {
            gameid, 
            serverid: gameserverid,
            isLoadingList,
        } = this.state;

        const { isloading } = this.props;

        const sellerListIdsByGameAndServerId = this.props.sellerListIdsByGameAndServerId[`${gameid},${gameserverid}`] || [];

        return (
            <Container>
                <Header>
                    <HeaderText>品牌旗艦館會員</HeaderText>
                    <HeaderText>信用評價</HeaderText>
                    <HeaderText>台幣：虛幣</HeaderText>
                    <HeaderText>庫存</HeaderText>
                    <HeaderText>交易時間與地點</HeaderText>
                    <HeaderText>確認交易</HeaderText>
                </Header>
                <List>
                    {/* <CupoyListRepeat
                        ref={_ref => (this.list = _ref)}
                        rowRenderer={this.rowRenderer}
                        listId={this.constructor.name}
                        items={sellerListIdsByGameAndServerId}
                        isLoading={this.props.isloading}
                        useWindowScroll
                        restoreWindowScroll
                        loadMoreRows={this.fetchSeller}
                    /> */}
                    <CupoyInfiniteScroll
                        data={sellerListIdsByGameAndServerId}
                        onEndReached={this.fetchSeller}
                        renderItem={this.renderItem}
                    />
                </List>
                {(isloading || isLoadingList) && this.renderLoading()}
                {this.props.error ?
                    <GlobalStyle.ErrorContainer>
                        <GlobalStyle.ErrorContainerTitle>
                            發生錯誤
                        </GlobalStyle.ErrorContainerTitle>
                        <GlobalStyle.ErrorContainerDesription>
                            無法取得列表，請重新整理後再嘗試。
                        </GlobalStyle.ErrorContainerDesription>
                    </GlobalStyle.ErrorContainer>
                    :
                    null
                }
                {this.state.isEmpty ?
                    <GlobalStyle.ErrorContainer>
                        <GlobalStyle.ErrorContainerTitle>
                            查無資料
                        </GlobalStyle.ErrorContainerTitle>
                        <GlobalStyle.ErrorContainerDesription>
                            無庫存資料
                        </GlobalStyle.ErrorContainerDesription>
                    </GlobalStyle.ErrorContainer>
                    :
                    null
                }
            </Container>
        );
    }

    renderItem = ({
        key, // Unique key within array of rows
        index, // Index of row within collection
    }) => {

        const { haslogin } = this.props;
        const { gameid, serverid: gameserverid } = this.state;
        const seller = this.props.sellerMap[key];

        const {
            nickname = '',
            notice = '',
            inventory = 0,
            ntdollar = 0,
            vitemdollar = 0,
            viprovid,
        } = seller;

        const isOpen = GLOBAL.getVProviderIsOpen(seller);

        return (
            <ListItem key={key}>
                <Name isOpen={isOpen}>{nickname.trim()}</Name>
                <Star className="zmdi zmdi-star" />
                <Money>{`${ntdollar} : ${vitemdollar}`}</Money>
                <Stock>{inventory}</Stock>
                <Info>{notice.trim()}</Info>
                {
                    haslogin ? 
                    <CupoySrefView
                        statename={CupoyRouter.STATES.GAME_SALE_DETAIL}
                        params={{
                            gameid,
                            serverid: gameserverid,
                            viprovid,
                        }}
                    >
                        <Button>
                            購買
                        </Button>
                    </CupoySrefView>
                    :
                    <Button onClick={this.showLogin}>
                        購買
                    </Button>
                }
            </ListItem>
        );
    }

    renderLoading = () => (
        <GlobalStyle.LoadingContainer>
            <GlobalStyle.Spin />
        </GlobalStyle.LoadingContainer>
    )

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        haslogin: state.member.haslogin,
        sellerMap: state.vitem.sellerMap,
        isloading: state.vitem.isloading,
        sellerListIdsByGameAndServerId: state.vitem.sellerListIdsByGameAndServerId,
        error: state.vitem.error,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        vitemActions: bindActionCreators(actionCreators.vitemActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(GameSaleView);